import scrollAction from "../services/scrollAction.js";
function showTopMenuAndArrows() {
	scrollAction("hide__menu", "white__menu");
}

export default showTopMenuAndArrows;
